import { styled } from '@mui/material';
import { TabList } from '@mui/lab';
import { up } from '../../../theme';

export const classes = {
  root: 'root',
  paymentButton: 'paymentButton',
  tabsBox: 'tabsBox',
  tabSectionHeaderGrid: 'tabSectionHeaderGrid',
  accountInfoMainHeading: 'accountInfoMainHeading',
  tabs: 'tabs',
  tabList: 'tabList',
  tabPanel: 'tabPanel',
  selectedTab: 'selectedTab',
  activityHistoryAgGridStyle: 'activityHistoryAgGridStyle',
  dateValueBox: 'dateValueBox',
};

export const StyledTabList = styled(TabList)(({ theme }) => ({
  '& .MuiTabs-indicator': {
    backgroundColor: theme.palette.primary.main,
    height: '0.370vh',
    borderTopLeftRadius: '5px',
    borderTopRightRadius: '5px',
  },
}));

export const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    [up('xs')]: {
      height: `calc(100vh - ${theme.spacing(6)});`,
      padding: '20px',
    },
  },
  [`& .${classes.paymentButton}`]: {
    background: theme.palette.primary.main,
    color: theme.palette.secondaryWhite.main,
    marginRight: '0.573vw',
    ':hover': {
      background: theme.palette.primary.main,
      color: theme.palette.secondaryWhite.main,
      marginRight: '0.573vw',
    },
    [up('xs')]: {
      width: '115px',
      height: '30px',
    },
    [up('sm')]: {
      width: '105px',
      height: '29px',
    },
    [up('md')]: {
      width: '135px',
      height: '35px',
    },
    [up('lg')]: {
      width: '140px',
      height: '40px',
    },
    [up('xl')]: {
      width: '155px',
      height: '47px',
    },
    [up('xxl')]: {
      width: '194px',
      height: '54px',
    },
  },
  [`& .${classes.tabsBox}`]: {
    borderBottom: 1,
    borderColor: theme.palette.darkPurple.lightest,
  },
  [`& .${classes.tabs}`]: {
    fontFamily: 'Heebo',
    fontWeight: 400,
    textTransform: 'none',
    [up('xs')]: {
      padding: '18px 14px',
    },
    [up('sm')]: {
      padding: '8px 14px',
    },
    [up('md')]: {
      padding: '10px 18px',
    },
    [up('lg')]: {
      padding: '12px 22px',
    },
    [up('xl')]: {
      padding: '14px 26px',
    },
    [up('xxl')]: {
      padding: '16px 30px',
    },
  },
  [`& .${classes.tabList}`]: {
    fontWeight: 400,
    color: theme.palette.shoeWax.darker,
  },
  [`& .${classes.selectedTab}`]: {
    fontWeight: 600,
    color: theme.palette.primary.main,
  },
  [`& .${classes.tabPanel}`]: {
    padding: 0,
    marginTop: '1vh',
  },
  [`& .${classes.tabSectionHeaderGrid}`]: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    [up('xs')]: {
      height: '30px',
    },
    [up('sm')]: {
      height: '29px',
    },
    [up('md')]: {
      height: '35px',
    },
    [up('lg')]: {
      height: '40px',
    },
    [up('xl')]: {
      height: '47px',
    },
    [up('xxl')]: {
      height: '54px',
    },
  },
  [`& .${classes.accountInfoMainHeading}`]: {
    color: theme.palette.darkPurple.main,
    alignItems: 'center',
    marginLeft: '0.2vw',
  },
  [`& .${classes.activityHistoryAgGridStyle}`]: {
    [up('xs')]: {
      height: '50vh',
    },
    [up('sm')]: {
      height: '62vh',
    },
    [up('md')]: {
      height: '61vh',
    },
    [up('lg')]: {
      height: '65vh',
    },
    [up('xl')]: {
      height: '74vh',
    },
    [up('xxl')]: {
      height: '76vh',
    },
  },
  [`& .${classes.dateValueBox}`]: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));
